/* Slider */
export const GET_IMAGES_SUCCESS = "get_images_success";
export const SET_TRANSLATE_VALUE = "set_translate_value";
export const SET_INDEX = "set_index";
/* Settings */
export const TOGGLE_SETTING = "toggle_setting";
export const TOGGLE_AUTOPLAY = "toggle_autoplay";
export const SET_NAVIGATION = "set_navigation";
export const GET_ANNOUNCEMENT = "get_announcement";
export const GET_ABOUT_US = "get_about_us";
export const GET_CONFIG = "get_config";
export const CREATE_REVIEWS = "create_reviews";
export const ERR_REVIEWS = "err_reviews";
export const CREATE_CARD_APPLICATIONS = "create_card_applications";
export const ERR_CARD_APPLICATIONS = "err_card_applications";
export const GET_POST = "get_post";
export const GET_SINGLE_POST = "get_single_post";
export const UPDATE_SCREEN = "update_screen";
export const GET_CATEGORIES = "get_categories";
export const GET_SUB_CATEGORIES_POST = "get_sub_categories_post";
export const GET_BRANCHES = "get_branches";
export const GET_ATMS = "get_atms";
export const GET_SINGLE_ANNOUNCEMENT = "get_single_announcement";
export const GET_ORGANIZATION = "get_organization";
export const GET_MONEY_GRAM = "get_money_gram";
export const GET_TEAMS = "get_teams";
export const GET_CRITERIA = "get_criteria";
export const CALCULATE_LOAN = "calculate_loan";
export const ERR_CALCULATE_LOAN = "err_calculate_loan";

export const GET_SUB_CATEGORY = "GET_SUB_CATEGORY";
export const GET_CATEGORY = "GET_CATEGORY";
export const GET_BULTENS = "GET_BULTENS";
export const GET_BULTEN = "GET_BULTEN";
export const GET_CARDS = "GET_CARDS";
export const GET_PAGE = "GET_PAGE";
export const GET_SINGLE_PAGE = "GET_SINGLE_PAGE";
export const GET_CREDITS = "GET_CREDITS";
export const GET_CREDIT_TYPE = "GET_CREDIT_TYPE";
